import { makeAutoObservable } from 'mobx'

export type ModalType = 'support' | 'bill'

export type ModalData = {
  type: ModalType
  orderId?: string
  activeTariffId?: string | null
}

export type Value = ModalData | null

class Store {
  modal: Value = null

  constructor() {
    makeAutoObservable(this)
  }

  setShowModal(value: Value) {
    this.modal = value
  }
}

export const useStore = new Store()
